import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";

import TemplateStepperComponent from "../../components/Template/Template Create features/TemplateStepperComponent";
import TemplateMainBody from "../../components/Template/Template Create features/TemplateMainBody";
import TemplateNavigationButtons from "../../components/Template/Template Create features/TemplateNavigationButtons";
import TemplatePreview from "../../components/Template/Template Create features/Preview/TemplatePreview";
import {
  nextStep,
  previousStep,
} from "../../redux/Slice/Templates/templateSlice";
import { fetchUserPermissions } from "../../redux/Slice/User/userDetailsSlice";
import AuthView from "../../utils/AuthView";

const TemplateCreate = () => {
  const dispatch = useDispatch();
  const { userPermissions } = useSelector((state) => state.userDetails);

  // Check if user has permission to view templates
  const canViewTemplates = userPermissions?.permissions?.Templates?.View || false;

  useEffect(() => {
    dispatch(fetchUserPermissions());
  }, [dispatch]);

  const handleNext = () => {
    dispatch(nextStep());
  };

  const handleBack = () => {
    dispatch(previousStep());
  };
  const { activeStep } = useSelector((state) => state.template);
  const istemplateSetup = activeStep === 0;
  const istemplateCreate = activeStep === 1;

  // If user doesn't have permission to view templates
  if (!canViewTemplates) {
    return <AuthView />;
  }

  return (
    <Box
      sx={{
        height: "100%",
        backgroundColor: (theme) => theme.palette.background.default,
        padding: { xs: "10px", sm: "15px", md: "20px", lg: 0, xl: 0 },
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxHeight: { xs: "calc(100vh - 100px)", sm: "calc(100vh - 100px)", md: "calc(100vh - 100px)", lg: "87vh", xl: "87vh" },
          display: "flex",
          flexDirection: "column",
          backgroundColor: (theme) => theme.palette.background.default,
          mb: { xs: 1, sm: 1.5, md: 2, lg: 2, xl: 2 },
        }}
      >
        {/* Upper Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "column", md: "column", lg: "row", xl: "row" },
            gap: { xs: 1, sm: 1.5, md: 2, lg: 6, xl: 6 },
            padding: { xs: "8px", sm: "10px", md: "12px", lg: "1% 5%", xl: "1% 10%" },
            flexGrow: 1,
            overflowY: "auto",
            minHeight: 0,
            paddingBottom: { xs: "100px", sm: "100px", md: "20px", lg: 0, xl: 0 },
            // Hide scrollbar below md (xs/sm); keep scrolling; md+ unchanged
            scrollbarWidth: { xs: "none", md: "auto" },
            msOverflowStyle: { xs: "none", md: "auto" },
            "&::-webkit-scrollbar": {
              width: { xs: 0, md: 8 },
              height: { xs: 0, md: 8 },
            },
          }}
        >
          {/* Left Section: Stepper + Main Body (70%) */}
          <Box
            sx={{
              width: { xs: "100%", sm: "100%", md: "100%", lg: "70%", xl: "70%" },
              display: "flex",
              flexDirection: "column",
              gap: { xs: 1.5, sm: 2, md: 2, lg: 2, xl: 2 },
              ...(istemplateSetup && {
                position: { xs: "relative", sm: "relative", md: "relative", lg: "sticky", xl: "sticky" },
                top: { xs: 0, sm: 0, md: 0, lg: 10, xl: 10 },
              }),
            }}
          >
            <TemplateStepperComponent />
            <TemplateMainBody />
          </Box>

          {/* Right Section: Preview (30%) */}
          <Box
            sx={{
              width: { xs: "100%", sm: "100%", md: "100%", lg: "30%", xl: "30%" },
              maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "30%", xl: "30%" },
              ...(istemplateCreate && {
                position: { xs: "relative", sm: "relative", md: "relative", lg: "sticky", xl: "sticky" },
                top: { xs: 0, sm: 0, md: 0, lg: 10, xl: 10 },
              }),
            }}
          >
            <TemplatePreview />
          </Box>
        </Box>

        {/* Lower Section: Navigation */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mb: { xs: 0.5, sm: 1, md: 1, lg: 1, xl: 1 },
            px: { xs: 1, sm: 2, md: 2, lg: 0, xl: 0 },
            flexShrink: 0,
            position: { xs: "fixed", sm: "fixed", md: "relative", lg: "relative", xl: "relative" },
            bottom: { xs: "70px", sm: "70px", md: "auto", lg: "auto", xl: "auto" },
            left: { xs: 0, sm: 0, md: "auto", lg: "auto", xl: "auto" },
            right: { xs: 0, sm: 0, md: "auto", lg: "auto", xl: "auto" },
            zIndex: { xs: 999, sm: 999, md: 1, lg: "auto", xl: "auto" },
            backgroundColor: { xs: (theme) => theme.palette.background.default, sm: (theme) => theme.palette.background.default, md: (theme) => theme.palette.background.default, lg: "transparent", xl: "transparent" },
            paddingTop: { xs: "8px", sm: "10px", md: "12px", lg: 0, xl: 0 },
            paddingLeft: { xs: "10px", sm: "15px", md: "20px", lg: 0, xl: 0 },
            paddingRight: { xs: "10px", sm: "15px", md: "20px", lg: 0, xl: 0 },
            boxSizing: "border-box",
            mt: { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 },
          }}
        >
          <TemplateNavigationButtons
            handleNext={handleNext}
            handleBack={handleBack}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TemplateCreate;
